import { Row, Col } from "react-bootstrap";

export const TypeBarSkeleton = () => (
  <div className="d-flex flex-column gap-2">
    {Array(5)
      .fill(0)
      .map((_, idx) => (
        <div
          key={idx}
          className="skeleton"
          style={{ height: "40px", borderRadius: "4px" }}
        />
      ))}
  </div>
);

export const BrandBarSkeleton = () => (
  <div className="d-flex flex-wrap gap-2 mb-3">
    {Array(6)
      .fill(0)
      .map((_, idx) => (
        <div
          key={idx}
          className="skeleton"
          style={{ width: "100px", height: "40px", borderRadius: "20px" }}
        />
      ))}
  </div>
);

export const DetailListSkeleton = () => (
  <Row>
    {Array(6)
      .fill(0)
      .map((_, idx) => (
        <Col key={idx} md={4} className="mb-4">
          <div
            className="skeleton"
            style={{ height: "300px", borderRadius: "8px" }}
          />
        </Col>
      ))}
  </Row>
);